module.exports = __webpack_public_path__ + "img/reason17.97696cb7.png";